// extracted by mini-css-extract-plugin
module.exports = {"container":"track-shipment_container__XO3Vm","hero":"track-shipment_hero__MrAYZ"};